import React from 'react'
import { SearchStatusPropsValue } from '../../../search'

interface SearchResultNbProps {
  searchStatus?: SearchStatusPropsValue
  type?: 'offers' | 'firms'
}

export const SearchResultNb = ({
  searchStatus = undefined,
  type = 'offers',
}: SearchResultNbProps) => {
  if (!searchStatus) {
    return null
  }
  const { nbResults, isLoading } = searchStatus

  if (isLoading) {
    return (
      <p className="text-night">
        <strong>Chargement...</strong>
      </p>
    )
  }

  if (!nbResults || nbResults === 0) {
    return (
      <span className="font-thin text-night">
        {getNoResultsLabelBasedOnType(type)}
      </span>
    )
  }
  return (
    <p className="text-night">
      <strong>{nbResults}</strong>&nbsp;{getLabelBasedOnType(type, nbResults)}
    </p>
  )
}

function getLabelBasedOnType(type: 'offers' | 'firms', nb: number) {
  const isNbResultsPlural = nb > 1
  switch (type) {
    case 'offers':
      return isNbResultsPlural ? "offres d'emploi" : "offre d'emploi"
    case 'firms':
      return isNbResultsPlural ? 'cabinets' : 'cabinet'
    default:
      return 'offre'
  }
}

function getNoResultsLabelBasedOnType(type?: 'offers' | 'firms') {
  switch (type) {
    case 'offers':
      return "Aucune offre d'emploi ne correspond à votre recherche"
    case 'firms':
      return 'Aucun cabinet ne correspond à votre recherche'
    default:
      return 'Aucun résultat ne correspond à votre recherche'
  }
}
